import React from 'react';
import { authService } from '../services/auth';
import SplashScreen from './SplashScreen';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const isAuthenticated = authService.isAuthenticated();

  if (!isAuthenticated) {
    return <SplashScreen />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
